module.exports = __webpack_public_path__ + "img/beforebee.89e8457c.svg";